<template>
    <template v-if="inclFB">ConsumoOxigeno.vue: template beg<br></template>
    <template v-if="inclFB">
        ConsumoOxigeno.vue: props: idFaena={{ idFaena }}, consumo_oxigeno={{ consumo_oxigeno }},
        seriesFaenas={{ seriesFaenas }}, consOxig={{ consOxig }}.<br>
    </template>
    <div>
        <ModalPeriodoConsumoOxigeno :show="showModal" :seriesFaenas="seriesFaenas" @close="closeModal">
        </ModalPeriodoConsumoOxigeno>
        <span class="font-semibold "> {{ $t('consumo_oxigeno') }}</span>

        <table class="divide-gray-300  border-spacing-0 m-0">
            <tbody class="divide-y divide-gray-200 bg-white ">

                <tr>
                    <td class="whitespace-nowrap py-0    text-xs   text-gray-900 ">{{ $t('hoy') }} {{ diahoy }}:</td>
                    <td class="whitespace-nowrap px-3 pl-2 py-2 text-xs text-gray-700">
                        <span class="tonelaje">{{ this.consAcum[0] }}</span><span> ton</span>
                    </td>
                </tr>

                <tr>
                    <td class="whitespace-nowrap py-0   text-xs   text-gray-900"> {{ $t('mesencurso') }}:</td>
                    <td class="whitespace-nowrap px-3 pl-2 py-2 text-xs text-gray-700">
                        <span class="tonelaje">{{ this.consAcum[1] }}</span><span> ton</span>
                    </td>
                </tr>

                <tr>
                    <!-- <td class="whitespace-nowrap py-0  text-xs   text-gray-900 "> {{ $t('periodocontar') }} {{ $t('from') }} {{ '15' }} {{  $t('Marzo')}} {{ '2025' }}:</td> -->
                    <!-- <td class="whitespace-nowrap py-0  text-xs   text-gray-900 "> {{ $t('periodocontar') }}:</td> -->
                    <td class="whitespace-nowrap py-0  text-xs   text-gray-900 "> {{ $t('periodocontar') }} {{ this.fechaDesde }}:</td>
                    <td class="whitespace-nowrap px-3 pl-2 py-2 text-xs text-gray-700">
                        <span class="tonelaje">{{ this.consAcum[2] }}</span><span> ton</span>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
    <template v-if="inclFB">CosumoOxigeno.vue: template end<br></template>
</template>
<style scoped>
.tonelaje {
    display: inline-block;
    width: 8ch;
    text-align: right;
    font-variant-numeric: tabular-nums;
}
</style>
<script>
import axios from "axios";
export default {
    props: [
        "idFaena", "consumo_oxigeno", "seriesFaenas", "consOxig"
    ],
    data() {
        return {
            visible: false,
            showModal: false,
            valores: Array,
            diahoy: '',
            mescurso: '',
            nomMes: ['', 'Jan', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            consAcum: [0, 0, 0],
            fechaDesde: '',
            inclFB: false
        }
    },
    components: {

    },
    mounted() {

        // this.valores=["0.7", "9.6","82.3"]

        let objFechaHora = this.$store.getters.fechaHoraActual();
        console.log("ConsumoOxigeno.vue: objFechaHora=", objFechaHora);
        let año = objFechaHora.getFullYear;
        let mes = parseInt(objFechaHora.getMonth);
        let dia = parseInt(objFechaHora.getDate);

        // Formatear la fecha en el formato deseado (por ejemplo, YYYY-MM-DD)
        this.mescurso = this.nomMes[Number(mes)]
        this.diahoy = ((dia < 10 ? '0' : '') + dia) + ' ' + this.nomMes[Number(mes)] + ' ' + año;
        console.log("ConsumoOxigeno.vue: diahoy=", this.diahoy);

    },
    methods: {
        modalPeriodos() {
            //console.log('modal periodos')
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false
            //console.log('cerrar modal 2');
        },
        fechaISOtoChilenita(fechaISO) {
            const [día, mes, año] = new Date(fechaISO + 'T00:00:00').toLocaleDateString('es-ES', {
                // day: '2-digit',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            }).split(' ');
            const resultado = `${día} ${mes.charAt(0).toUpperCase() + mes.slice(1)} ${año}`;
            console.log(resultado); // "31 Jul 2026"
            return resultado;
        },
        async getConsumption(startDate, endDate, indice) {
            let dataFaena = [];
            try {
                let sumatoria = 0;
                let unafecha='';
                const apiKey = this.$store.state.login.tokenLogin;
                const objStoreFaenas = this.$store.state.faenas;
                let arrayFaenas = [];
                this.objFaena = objStoreFaenas.faenas.filter(faena => faena.id == this.idFaena);
                arrayFaenas = this.objFaena;
                // Se creará una promesa por cada elemento de arrayFaenas, aunque lo normal es que haya solamente 1 elemento.
                const centerPromises = arrayFaenas.map((faena) => {
                    this.glosaDataType = false;
                    if (faena.id !== undefined) {
                        const requestData = {
                            idCenter: this.idFaena,
                            startDay: `${startDate}`, // ya viene con 00:00:00
                            finishDay: `${endDate}`, // ya viene con 23:59:59
                            granularity: ''
                        };
                        return axios
                            .post("/api/ctl/getCenterConsumption", requestData, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `${apiKey}`,
                                },
                            })
                            .then((response) => {
                                this.glosaDataType = response.data.payload.dataType == 'dummy' ? true : false;
                                let gas = response.data.payload.gas;
                                gas.forEach(g => {
                                    g.consumption.forEach(fema => {
                                        let fecha = fema.fechaInicial;
                                        let masa = fema.masa;
                                        masa = parseFloat(masa);
                                        sumatoria += masa;
                                        unafecha=fecha;
                                        // if (indice == 0) console.log("totals", indice, med, arrayLecturasLocal[indice])
                                    });
                                });
                            })
                            .catch((error) => {
                                console.log("Error al obtener datos del centro", error);
                                return [];
                            });
                    }
                });
                await Promise.all(centerPromises);
                this.valorMaxY0 = 0;
                this.valorMinY0 = 0;
                // Array Reactivo    =  data []
                this.dataCapMaxima = [];
                // Array Reactivo    =  data []
                this.consAcum[indice] = sumatoria == null ? 0 : sumatoria.toFixed(2);
                if (this.consAcum[indice] > 0) {
                    this.consAcum[indice] = this.consAcum[indice] / 1000;
                    this.consAcum[indice] = this.consAcum[indice].toFixed(2);
                }
                this.fechaDesde=this.fechaISOtoChilenita(unafecha);
                // data [ ]        =   Array Reactivo 
                //this.seriesDiarias = this.series;
                if (this.glosaDataType) {
                    if (indice >= 0 && indice < this.categoriaMeses.length) {
                        //  this.categoriaMeses[indice] = `${this.categoriaMeses[indice]} ${i18n.global.t('Simulado')}`;
                        this.categoriaMeses[indice] = `${this.categoriaMeses[indice]} `;
                    }
                }
                return dataFaena;
            } catch (error) {
                console.log("error procesando faenas", error);
            }
        },
        fechashoras() {
            //            const fmt = d => d.toISOString().slice(0, 19).replace('T', ' '); // GMT
            const fmt = d => d.toLocaleString('sv-SE'); // LOCAL
            const now = new Date();
            const h0 = (d, h) => (d.setHours(h, 0, 0, 0), fmt(d));
            const penultimaHora = h0(new Date(now), Math.max(now.getHours() - 1, 0));
            const primerSegundoDia = h0(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 0);
            const primerSegundoMes = h0(new Date(now.getFullYear(), now.getMonth(), 1), 0);
            const epoch = fmt(new Date(0));  // 2026-07-31 03:23:57  por ejemplo
            console.log(penultimaHora);      // 2026-07-31 02:00:00
            console.log(primerSegundoDia);   // 2026-07-31 00:00:00
            console.log(primerSegundoMes);   // 2026-07-01 00:00:00
            console.log(epoch);              // 1970-01-01 00:00:00
            /*            
            let fh=[[],[],[]];
            fh[0][0] = primerSegundoDia;
            fh[0][1] = penultimaHora;
            fh[1][0] = primerSegundoMes;
            fh[1][1] = penultimaHora;
            fh[2][0] = epoch;
            fh[2][1] = penultimaHora;
            return fh;
            */
            return [
                [primerSegundoDia, penultimaHora],
                [primerSegundoMes, penultimaHora],
                [epoch, penultimaHora]
            ];
        },
        async setConsumption() {
            this.fechaDesde=this.fechaISOtoChilenita(this.consOxig.beg);
            this.consAcum[0]=(this.consOxig.day/1000).toFixed(2);
            this.consAcum[1]=(this.consOxig.mon/1000).toFixed(2);
            this.consAcum[2]=(this.consOxig.per/1000).toFixed(2);
        },
        async cargarDatosSlow() {
            let fh = this.fechashoras();
            await this.getConsumption(fh[0][0], fh[0][1], 0);
            await this.getConsumption(fh[1][0], fh[1][1], 1);
            await this.getConsumption(fh[2][0], fh[2][1], 2);
        },
        async cargarDatos() {
            await this.setConsumption();
        }
    },
    watch: {
        diahoy: function () {
            this.cargarDatos();
        }
    }
} 
</script>
